import Step from './Step';

class Lesson {
  constructor({ lessonDefinition }) {
    this.steps = [];
    if (lessonDefinition == null) {
      return;
    }
    this.name = lessonDefinition.name;

    lessonDefinition.steps.forEach((stepDefinition) => {
      const stepSlug = stepDefinition.slug;
      this.steps.push(new Step({ stepSlug, stepDefinition }));
    });

    // eslint-disable-next-line operator-linebreak
    this.imageSubPath =
      'imageSubPath' in lessonDefinition ? lessonDefinition.imageSubPath : '';

    // Do some validation
    const stepSlugs = new Set();
    this.steps.forEach((step) => {
      const stepSlug = step.slug();
      if (stepSlugs.has(stepSlug)) {
        throw Error('Same stepSlug found for different steps');
      }
      stepSlugs.add(stepSlug);
    });
  }

  numSteps() {
    return this.steps.length;
  }

  lessonName() {
    return this.name;
  }

  stepAtIdx0(idx) {
    if (idx < this.steps.length) {
      return this.steps[idx];
    }
    return null;
  }

  step(stepSlug) {
    let stepFound = null;
    this.steps.forEach((step) => {
      if (step.slug() === stepSlug) {
        stepFound = step;
      }
    });
    return stepFound;
  }

  stepIdx0(stepSlug) {
    let stepIdx = -1;
    this.steps.forEach((step, idx) => {
      if (step.slug() === stepSlug) {
        stepIdx = idx;
      }
    });
    return stepIdx;
  }

  nextStep(curStepSlug) {
    const stepIdx = this.stepIdx0(curStepSlug);
    const nextStep = this.stepAtIdx0(stepIdx + 1);
    return nextStep;
  }

  prevStep(curStepSlug) {
    const stepIdx = this.stepIdx0(curStepSlug);
    const prevStep = stepIdx - 1 >= 0 ? this.stepAtIdx0(stepIdx - 1) : null;
    return prevStep;
  }

  imageSubPath() {
    return this.imageSubPath;
  }
}

export default Lesson;
